// NOTE:
// Decimals which we use for WEI from backend (BOT)
export const BOT_USD_DECIMALS: Readonly<number> = Number(process.env.VUE_APP_BOT_USD_DECIMALS) || 6;
